import React, { Component } from "react";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { Menu, MenuItem, IconButton } from "@material-ui/core";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import swal from "sweetalert";
import { SemipolarLoading } from "react-loadingg";
class ExportToExcel extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false, anchorEl: null, fileName: "Leads" };
  }

  exportToClick = event => {
    this.setState({ anchorEl: event.currentTarget });
    event.stopPropagation();
  };

  exportToClose = () => {
    this.setState({ anchorEl: null });
  };

  setDataWithHeader = fileData => {
    let filedata = [];
    fileData.length > 0
      ? fileData.map(item => {
          filedata.push({
            Name: item.name,
            "Current Company": item.organization,
            "Current Position": item.designation,
            Location: item.location,
            "Lead Status": item.Status,
            "Last Message Sent": item.Send_Msg,
            "Last Message Received": item.Received_Msg,
            Customer: item.Customer,
            Profile: item.Profile,
            "Campaign Name": item.Campaign,
            "Contact Status":
              item.campaignstatus === "COMPLETED"
                ? "Completed"
                : item.campaignstatus === "PAUSE"
                ? "Pause"
                : item.campaignstatus === "LIVE"
                ? "Live"
                : ""
          });
        })
      : filedata.push({
          Name: "",
          "Current Company": "",
          "Current Position": "",
          Location: "",
          "Lead Status": "",
          "Last Message Sent": "",
          "Last Message Received": "",
          Customer: "",
          Profile: "",
          "Campaign Name": "",
          "Contact Status": ""
        });
    return filedata;
  };

  exportToExcel = (fileData, fileName) => {
    if (this.props.fileData && this.props.fileData.length > 0) {
      let filedata = this.setDataWithHeader(fileData);
      try {
        const fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        const fileExtension = ".xlsx";
        const name = "Leads";
        const ws = XLSX.utils.json_to_sheet(filedata);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, {
          bookType: "xlsx",
          type: "array"
        });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, name + fileExtension);
        this.exportToClose();
      } catch (e) {
        swal("Error", { icon: "error" });
      }
      this.setState({ loading: false });
    } else {
      this.setState({ loading: true });
      setTimeout(() => {
        this.exportToExcel(this.props.fileData, fileName);
      }, 5000);
    }
  };

  render() {
    if (this.state.loading) {
      return (
        <div className="spinner">
          <SemipolarLoading size={70} color={"#3865dd"} />
        </div>
      );
    }
    const { anchorEl, fileData, fileName } = this.state;
    return (
      <div className={"moreVertIcon"}>
        {" "}
        <IconButton
          aria-controls="simple-menu"
          aria-haspopup="true"
          onClick={this.exportToClick}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={this.exportToClose}
          PaperProps={{
            style: {
              marginTop: 38,
              marginLeft: "-28px"
            }
          }}
        >
          <MenuItem
            onClick={() => {
              this.exportToExcel(this.props.fileData, fileName);
            }}
          >
            Export To Excel
          </MenuItem>
        </Menu>
      </div>
    );
  }
}

export default ExportToExcel;
